import { mapState, mapGetters, mapActions } from 'vuex'

export const deviceDetailListComputed = {
  ...mapState('deviceDetails', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('deviceDetails', ['getDeviceChart']),
}

export const deviseDetailListMethods = mapActions('deviceDetails', [
  'fetchingDeviceChart',
  'fetchDeviceById',
])
